module.exports = __webpack_public_path__ + "img/icon_open.eae62d5f.svg";